const { createClient } = require('contentful');

module.exports = createClient({
  space: 's16ms59qcevs',
  accessToken: 's1RN1KNFS3Tqpn5zFVGXTpVfKSTEAIr1p0mFTycMH7U',
});
